import React, { useState } from "react";
import {
  Box,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Grid,
  Tooltip,
  TextField,
  Alert,
  Button,
} from "@mui/material";

//MUI ICONS
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Receipt as ReceiptIcon,
  Business as BusinessIcon,
  Inventory as InventoryIcon,
  FormatListBulleted as FormatListBulletedIcon,
  Save as SaveIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Visibility as VisibilityIcon,
  Person as PersonIcon,
  BusinessCenter as BusinessCenterIcon,
  Payment as PaymentIcon,
  PropaneTank as PropaneTankIcon,
  AttachMoney as AttachMoneyIcon,
  AddCircleOutline as AddCircleOutlineIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Autocomplete from "@mui/material/Autocomplete";

//CUSTOM IMPORTS
import ModalAyuda from "../ModalAyuda";
import DialogSelecComprobante from "../dialogs/DialogSelecComprobante";
import { getData } from "../../../../services/library";
import { hasFullAccess } from "../../../../utils/filters";

function DataFactura({
  dataCliente,
  formData,
  setFormData,
  comprobanteAsociado,
  setComprobanteAsociado,
  showCheckConsFinal,
  setShowCheckConsFinal,
  anulacionCompleta,
  setAnulacionCompleta,
  permisos,
  sucursales,
  // sucTieneAlias,
  paramsNegocios,
  setItems,
  tipoComprobante,
  empresas,
  getSucEmpresa,
  bgColor,
  limpiarItems,
  anulacionParcial,
  setAnulacionParcial,
  setTipoCbtePosible,
  userSucData
}) {
  const [showModalAyuda, setShowModalAyuda] = useState(false);
  const [showSelectorComprobante, setShowSelectorComprobante] = useState(false);
  const [showSelComprAsoc, setShowSelComprAsoc] = useState();
  const fullAccess = hasFullAccess();

  const getOptionDisabledEmpresas = (empresa) => {
    if (fullAccess) return false;
    const { negocios } = empresa;
    return !(negocios.split(",").map(negocio => Number(negocio)).includes(dataCliente?.id_negocio_cliente));
  }

  const getOptionDisabledSucursales = (sucursal) => {
    if (fullAccess) return false;
    return ((userSucData.id !== sucursal.id) && (userSucData.id_alias !== sucursal.id));
  }

  return (
    <div>
      <Box sx={{ backgroundColor: "primary.main", color: "white", p: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <ReceiptIcon />
            <Typography variant="h5" sx={{ fontWeight: 450, fontSize: 15 }}>
              Datos De Facturación
            </Typography>
          </Box>
          <Tooltip title="Ayuda">
            <HelpOutlineIcon
              sx={{ cursor: "pointer" }}
              onClick={() => {
                setShowModalAyuda(true);
              }}
            />
          </Tooltip>
        </Box>
      </Box>
      <CardContent sx={{ py: 4, px: 3 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={4} lg={4}>
            <FormControl fullWidth size="small" disabled={!dataCliente}>
              <InputLabel>Tipo Comprobante</InputLabel>
              <Select
                disabled={!dataCliente}
                value={formData.tipoCompGen}
                onChange={(e) => {
                  const params = JSON.parse(
                    tipoComprobante.find(
                      (tipo) =>
                        tipo.id_tipo_comprobante_generico === e.target.value
                    )?.params
                  );
                  setShowCheckConsFinal(Boolean(params?.a_cons_final));
                  setShowSelectorComprobante(
                    Boolean(params?.seleccionar_factura)
                  ); //Esto parametrizarlo de alguna forma. indica que cuando es nc abre un selector de comprobantes.
                  setShowSelComprAsoc(Boolean(params?.seleccionar_factura));
                  setFormData({
                    ...formData,
                    tipoCompGen: e.target.value,
                    idPedidoRemito: "",
                  });
                  limpiarItems();
                }}
                label="Tipo Comprobante"
              >
                {tipoComprobante.map((tipo) => (
                  <MenuItem
                    key={tipo.id_tipo_comprobante_generico}
                    value={tipo.id_tipo_comprobante_generico}
                  >
                    {tipo.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
              disabled={
                !dataCliente ||
                !permisos["facturaotraempresa"] ||
                // !sucTieneAlias ||
                comprobanteAsociado
              }
            >
              <InputLabel id="label-empresa-emisora">
                Empresa Que Factura
              </InputLabel>
              <Select
                sx={{ backgroundColor: bgColor }}
                value={formData.empEmisora}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    empEmisora: e.target.value,
                    // sucEmisora: sucTieneAlias ? formData.sucEmisora : "",
                    sucEmisora: userSucData?.id_alias ? formData.sucEmisora : "",
                  });
                  getSucEmpresa(e.target.value);
                  if (e.target.value !== dataCliente.id_empresa)
                    alert(
                      "Atención: Esta factura no estará en la empresa del cliente."
                    );
                }}
                label="Empresa Que Factura"
              >
                {empresas.map((empresa) => (
                  <MenuItem key={empresa.id} value={empresa.idempresa} disabled={getOptionDisabledEmpresas(empresa)}>
                    {empresa.empresa}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <Autocomplete
              disabled={
                !dataCliente ||
                !permisos["facturaotrasucursal"] ||
                // anulacionCompleta
                comprobanteAsociado
              }
              required
              disableClearable
              placeholder="Sucursal"
              options={sucursales || []}
              getOptionDisabled={(option) => getOptionDisabledSucursales(option)}
              value={
                sucursales?.find((s) => s.id === formData.sucEmisora) || null
              }
              onChange={(e, value) => {
                setFormData({
                  ...formData,
                  sucEmisora: value.id,
                });
                if (value?.id !== dataCliente.id_sucursal) {
                  alert(
                    "Atención: Esta factura no estará en la sucursal del cliente."
                  );
                }
              }}
              noOptionsText={"Sucursal Inexistente"}
              getOptionLabel={(option) => option?.nombre}
              renderOption={(props, option) => (
                <Box
                  component="li"
                  key={option.denominacion}
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {option.nombre}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  placeholder="Tipee para buscar sucursales.."
                  {...params}
                  variant="outlined"
                  size="small"
                  label="Sucursales"
                  required
                />
              )}
            />
          </Grid>
          {showCheckConsFinal && (
            <Grid item lg={12} md={12} xs={12}>
              <FormControlLabel
                disabled={
                  !dataCliente ||
                  Boolean(formData.aUsuario) ||
                  !dataCliente?.cuit?.trim()?.length
                }
                control={
                  <Checkbox
                    color="secondary"
                    checked={formData.aConsFinal === 1}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        aConsFinal: e.target.checked ? 1 : 0,
                      });
                      e.target.checked ?
                        getData(`/facturacion_tipos_comprobantes/iva/4`, setTipoCbtePosible) : getData(`/facturacion_tipos_comprobantes/iva/${Number(dataCliente.situacion_iva)}`, setTipoCbtePosible)
                    }}
                  />
                }
                label="A Consumidor Final"
              />
            </Grid>
          )}
          {showSelComprAsoc && !comprobanteAsociado && (
            <Grid item lg={12} md={12} xs={12}>
              <Alert
                severity="warning"
                action={
                  <Button
                    color="inherit"
                    size="small"
                    onClick={() => setShowSelectorComprobante(true)}
                  >
                    Seleccionar
                  </Button>
                }
              >
                Es obligatorio vincular este tipo de comprobantes a una factura.
              </Alert>
            </Grid>
          )}
          {comprobanteAsociado && (
            <>
              <Grid item lg={12} md={12} xs={12}>
                <Alert
                  severity="info"
                  action={
                    <Button
                      color="inherit"
                      size="small"
                      onClick={() => setShowSelectorComprobante(true)}
                    >
                      Modificar
                    </Button>
                  }
                >
                  {
                    anulacionCompleta ? (`Se emitirá una NC por la totalidad de la ${comprobanteAsociado?.texto_comprobante} ${comprobanteAsociado?.letra} ${comprobanteAsociado?.pto_venta}-${comprobanteAsociado?.nro_comprobante} (Total ${Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS", }).format(comprobanteAsociado?.importe_total)}) `) :
                      (`Se emitirá una NC parcial - Comprobante: ${comprobanteAsociado?.texto_comprobante}
                    ${comprobanteAsociado?.letra} ${comprobanteAsociado?.pto_venta}-
                    ${comprobanteAsociado?.nro_comprobante} || Total:  ${Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS", }).format(comprobanteAsociado?.importe_total)}`)
                  }
                </Alert>
              </Grid>
            </>
          )}

          {showSelectorComprobante && (
            <DialogSelecComprobante
              open={showSelectorComprobante}
              setOpen={setShowSelectorComprobante}
              dataCliente={dataCliente}

              comprobanteAsociado={comprobanteAsociado}
              setComprobanteAsociado={setComprobanteAsociado}

              paramsNegocios={paramsNegocios}
              setItems={setItems}
              anulacionCompleta={anulacionCompleta}
              setAnulacionCompleta={setAnulacionCompleta}
              setFormData={setFormData}
              anulacionParcial={anulacionParcial}
              setAnulacionParcial={setAnulacionParcial}
            />
          )}
        </Grid>
      </CardContent>
      {showModalAyuda && (
        <ModalAyuda
          open={showModalAyuda}
          setOpen={setShowModalAyuda}
          titulo={"Centro de ayuda."}
          subtitulo={
            "A continuación encontrarás información importante sobre el funcionamiento del sistema de facturación:"
          }
          modulo={"ventas_facturacion"}
          tip={`Si continúas teniendo problemas, verifica que todos los datos del cliente estén completos y correctos antes de intentar generar la factura.`}
        />
      )}
    </div>
  );
}

export default DataFactura;
